export default {
  setAccounts(context, payload) {
    context.commit("setAccounts", payload);
  },
  setProcedures(context, payload) {
    context.commit("setProcedures", payload);
  },
  setFilterOptions(context, payload) {
    context.commit("setFilterOptions", payload);
  },
  setFilters(context, payload) {
    context.commit("setFilters", payload);
  },
  resetFilters(context, payload) {
    context.commit("resetFilters", payload);
  },
  saveToken(context, payload) {
    context.commit("saveToken", payload);
  },
};
